'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_s_Conversion() {
}
export { $c_s_Conversion as $c_s_Conversion };
$p = $c_s_Conversion.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_Conversion;
/** @constructor */
function $h_s_Conversion() {
}
export { $h_s_Conversion as $h_s_Conversion };
$h_s_Conversion.prototype = $p;
$p.b = (function() {
  return "<function1>";
});
$p.cq = (function(x$0) {
});
